import { render, staticRenderFns } from "./Carts.vue?vue&type=template&id=0ef91773&"
import script from "./Carts.vue?vue&type=script&lang=ts&"
export * from "./Carts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports